import { Injectable } from '@angular/core';
import { FirestoreService } from './firestore/firestore.service';
import { Globals } from '../globals';

export interface DocumentType {
   name: string;
   folio: number;
   description: string;
}

@Injectable()
export class DocumentsTypesService {
  collection: string;
  constructor(
    private afh: FirestoreService
  ) {
    this.collection = Globals.DOCUMENTS_TYPES_COLLECTION;
  }

  /**
  * Se guarda la información de Tipos de Documentos
  * @param {data: DocumentType} Informacion del documento
  **/
  addDocument(data: DocumentType) {
    this.afh.add(`${this.collection}`, data);
  }

  getDocument(id: string) {
    return this.afh.docWithIds$(`${this.collection}/${id}`);
  }

  updateDocument(id: string, data: DocumentType) {
   this.afh.update(`${this.collection}/${id}`, data);
  }

  getDocumentsAll() {
    return this.afh.colWithIds$(`${this.collection}`, ref => ref.where('active', '==', true));
  }

  deleteDocument(id: string) {
    return this.afh.delete(`${this.collection}/${id}`) 
  }

}
